import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
// import ConvertTitle from './ConvertTitle';
import TimeInputSection from './TimeInputSection';
import { syncTimeDataToDrawer } from './formSync';
import { evaluateTimeReadOnlyCondition } from './conditionUtils';
import { useFormContext } from '../../Context/Context';
import { useReadOnly } from '../../Context/ReadOnlyContext';
import { FinalValuesContext } from '../../Context/FinalValuesContext';
import ConvertTitle from '../ConvertTitle';

const TimeSection = ({ id, header }) => {
  const { drawerData } = useFormContext();
  const location = useLocation();
  const { readOnly } = useReadOnly();
  const { finalSelectValues } = useContext(FinalValuesContext);
  const currentPage = location.pathname;

  const isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith('/card-form/publish') || currentPage.startsWith('/user/fill-form/');
  const existingComponentIndex = drawerData.findIndex(component => component.id === id);

  const theme = useTheme();
  const HeadingColor = theme.palette.blue[700];
  const gridRef = useRef(null);

  const [timeValue, setTimeValue] = useState(header || drawerData[existingComponentIndex]?.state?.timeValue || 'زمان');
  const [subTimeValue, setSubTimeValue] = useState(drawerData[existingComponentIndex]?.state?.subTimeValue || 'ساعت دقیقه');
  const [selectedOption, setSelectedOption] = useState(drawerData[existingComponentIndex]?.state?.selectedOption || 'ق.ظ');
  const [inputValue, setInputValue] = useState(drawerData[existingComponentIndex]?.state?.mainInputValue || '');
  const [condition, setCondition] = useState(false);
  const [border, setBorder] = useState(false);

  useEffect(() => {
    syncTimeDataToDrawer(drawerData, existingComponentIndex, {
      timeValue,
      subTimeValue,
      selectedOption,
      inputValue,
      readOnly,
    });
  }, [id, timeValue, subTimeValue, selectedOption, inputValue]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (gridRef.current && !gridRef.current.contains(e.target)) {
        setBorder(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  useEffect(() => {
    const title = ConvertTitle({ title: finalSelectValues.find(item => item.name === "FieldCondition")?.value });
    const dataCondition = drawerData.find(item => item.title === title)?.state?.readOnly;
    setCondition(evaluateTimeReadOnlyCondition(currentPage, readOnly, dataCondition, title));
  }, [finalSelectValues, readOnly]);

  return (
    <Grid
      ref={gridRef}
      onClick={() => setBorder(true)}
      mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
      p={drawerData.length > 0 ? (currentPage.startsWith('/build') || currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form') ? '12px 10px' : { xs: '12px', md: '24px' }) : '0px'}
      mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
      borderRadius="3px"
      bgcolor="white"
      border={border && drawerData.length > 0 && drawerData[existingComponentIndex] && !isReadOnly ? '2px solid #0293e2' : '2px solid transparent'}
    >
      <Grid pb="16px">
        <input
          className="customHead-input"
          placeholder="یک عنوان وارد کنید"
          style={{
            border: 'none',
            outline: 'none',
            width: '100%',
            fontSize: '16px',
            fontWeight: 700,
            color: HeadingColor,
          }}
          readOnly={isReadOnly || condition}
          value={timeValue}
          onChange={(e) => setTimeValue(e.target.value)}
          onFocus={e => !isReadOnly && e.target.select()}
        />
      </Grid>

      <TimeInputSection
        inputValue={inputValue}
        selectedOption={selectedOption}
        onInputChange={setInputValue}
        onOptionChange={setSelectedOption}
        condition={condition}
      />

      <Grid>
        <input
          placeholder="یک SubLabel وارد کنید"
          style={{
            border: 'none',
            outline: 'none',
            width: '100%',
            fontSize: '12px',
            fontWeight: 700,
            color: '#b8bdc9',
          }}
          readOnly={isReadOnly || condition}
          value={subTimeValue}
          onChange={(e) => setSubTimeValue(e.target.value)}
        />
      </Grid>
    </Grid>
  );
};

export default TimeSection;
